import { PopupsApi } from 'api';
import useUserData from 'hooks/useUserData';
import React, { useContext, useState, useEffect } from 'react';
import { OnboardingContext } from '../Onbording/OnboardingContext';
import { PopupProps } from './PopupModel';
export interface AdvertisementPopupContextProps {
  showed: boolean;
  setShowed: (showed: boolean) => void;
  popupConfig: PopupProps | null;
}
const Context = React.createContext<AdvertisementPopupContextProps>({
  showed: false,
  setShowed: () => {
    //nothing
  },
  popupConfig: null,
});

const AdvertisementPopupContext = (props: React.PropsWithChildren<{}>) => {
  const [showed, setShowed] = useState(false);
  const [popupConfig, setPopupConfig] = useState<PopupProps | null>(null);
  const userData = useUserData();

  const getPopupConfig = async () => {
    if (!userData?.id || !userData?.userType || window.location.href.includes('localhost')) {
      return;
    }

    const result = await PopupsApi.getPopups(userData.id, userData?.userType);
    if (result)
      setPopupConfig({
        id: result.id?.toString() || '',
        title: result.title || '',
        text: result.text || '',
        buttonTitle: result.buttonTitle || '',
        link: result.link || '',
      });
  };
  useEffect(() => {
    getPopupConfig();
  }, [userData?.id]);

  return <Context.Provider value={{ showed, setShowed, popupConfig }}>{props.children}</Context.Provider>;
};

export const usePopupContext = () => useContext(Context);

export default AdvertisementPopupContext;
